import { createContext, type ComponentType, type ReactNode } from 'react';

import type { LimuloTournament } from '@/types/limulo';

/**
 * LE PROPS DELLE QUATTRO TAB (`TorneiQuattroTab`, I-346), le stesse per tutte le porte: il pannello Eventi della Hub e la lista a tutta pagina (`LimuloTournaments`), la scheda «Tornei» del
 * backgammon (`QgammonTournamentsPanel`) e quella degli scacchi (`ChessTournamentsPanel`), e i tornei del Burraco (`TorneiBurraco`).
 *
 * @param pubblicati la lista pubblica GIA' del gioco della porta (`?gameId=`, #577) e gia' passata da `isPublished` e
 *   `nonEUnaSfida`; `null` = non c'e' (attesa, errore): le tre tab pubbliche mostrano `avviso`.
 * @param coda il «Carica altri» della paginazione del SERVER, in fondo alle tab pubbliche.
 * @param vuotoDelGioco la frase quando il gioco non ha NESSUN torneo nelle tre liste pubbliche (#577: il vuoto nomina il gioco,
 *   «Nessun torneo di {{game}} pubblicato.»). Se e' vuota una tab sola, la frase e' quella della tab.
 * @param gameIdMiei il `?gameId=` di `/mine` (derivazione di tma-orcb: dentro la sezione di un gioco anche le mie e il bollino
 *   sono di quel gioco). `undefined` = tutti i giochi; `null` = non si chiede, e «I miei» mostra `avviso`.
 */
export interface PropsListaTornei {
  pubblicati: LimuloTournament[] | null;
  avviso?: ReactNode;
  coda?: ReactNode;
  vuotoDelGioco: string;
  gameIdMiei: string | undefined | null;
}

/**
 * IL PUNTO D'INNESTO di una lista alternativa dei tornei. `TorneiQuattroTab` e' l'unico punto dove le porte convergono: se qualcuno sopra di lui ha messo un componente in questo Context, lo
 * rende al posto delle quattro tab, con le STESSE props (stessi dati, stessi cinque vuoti, stessa paginazione). Il valore di partenza e' `null`: senza nessuno sopra, le quattro tab sono quelle
 * di sempre e il DOM non cambia di un nodo (il test «porte identiche» sulle quattro porte, in `tests/`).
 * ⛔ Il valore di partenza resta `null`: un componente di default farebbe cambiare ogni porta per chiunque, anche dove nessuno l'ha scelto.
 */
export const SlotListaTornei = createContext<ComponentType<PropsListaTornei> | null>(null);
